import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-snooze-form",
    templateUrl: "./snooze-form.component.html",
    styleUrls: ["../row-action/row-action.component.scss"],
    standalone: false
})
export class SnoozeFormComponent {
    @Input() recName: string = '';
    @Output() submit = new EventEmitter<{ sumissionType: string, submissionValue: string | undefined }>();
    snoozeTimerSubmittal: string = '';

    constructor() { }

    updateSnoozeFormValue(event: number) {
        this.snoozeTimerSubmittal = event.toString();
    }

    submitSnooze() {
        this.submit.emit({ sumissionType: "snooze", submissionValue: this.snoozeTimerSubmittal });
        this.exitCover();
    }

    exitCover() {
        this.snoozeTimerSubmittal = '';
        this.submit.emit({ sumissionType: "close", submissionValue: undefined });
    }
}